module.exports = __webpack_public_path__ + "img/logo-horus-cor.2a8de29a.svg";